import React, {useState, useEffect} from "react";
import Accordion from "../accordion/Accordion";
// import {Grid, Col} from "../../styles/Grid";
// import {Label, Input} from "../forms/DynamicInput";
import HeadData from "./Data";
import styled from "styled-components";
// import EditableImg from "../forms/EditableImg";
import {ButtonWithIcon} from "../../styles/Butttons";
// import {ReactComponent as EditIcon} from "../../assets/icons/edit.svg";
import {ReactComponent as SeeIcon} from "../../assets/icons/eye.svg";
import SuccesModal from "../modals/SuccessModal";
import {HeadDropDown, RightHead} from "../../styles/ContentViews";
import ToogleForm from "./ToogleForm";
import {UpdateHeaderBlock, InfoHeaderBlock} from "../../services/GeneralServices";
import AppLoader from "../loaders/Loader";
import propTypes from "prop-types";
import {PageWebUrl} from "../../services/ApiUrl";

export default function ImgEncabezado({theme, title, status, changeMode, idUpdate, nameUpdate, titleDesc, viewTitle, linkWeb, video}) {
   const [data, setData] = useState({});
   const [editable, setEditable] = useState(false);
   const [isSaving, setSaving] = useState(false);
   const [currentData, setCurrentDta] = useState({description: ""});
   const [showSuccess, setShowSuccess] = useState(false);

   useEffect(() => {
      let currentData = HeadData.find((item) => {
         return item.type === viewTitle;
      });
      let cleanData = [
         {
            desc: "",
            subtitle: "",
            images: {},
         },
      ];
      setData(currentData || cleanData);
   }, [viewTitle]);

   useEffect(() => {
      getData();
   }, [nameUpdate]);

   const save = (e) => {
      e.preventDefault();
      setSaving(true);
      // enviar a saveUrl
      let form = e.target.elements;

      let dataSend = new FormData();
      dataSend.append("idHeader", idUpdate);
      dataSend.append("type", nameUpdate);
      dataSend.append("token", localStorage.getItem("domecq_token"));
      dataSend.append("description", form.description.value.replace(/\n/g, "<br>"));
      if (form[`desk${viewTitle}`].files) {
         dataSend.append("pathImageWebDesktop", form[`desk${viewTitle}`].files[0]);
      }
      if (form[`mobile${viewTitle}`].files) {
         dataSend.append("pathImageWebMobile", form[`desk${viewTitle}`].files[0]);
      }
      if (video) {
         if (form[`video${viewTitle}`].files) {
            dataSend.append("pathVideo", form[`desk${viewTitle}`].files[0]);
         }
      }
      UpdateHeaderBlock(dataSend)
         .then((res) => res.json())
         .then((resp) => {
            setSaving(false);
            setCurrentDta({...currentData, description: form.description.value.replace(/\n/g, "<br>")});
         })
         .then(() => {
            setShowSuccess(true);
         })
         .catch(() => {
            setSaving(false);
         });
   };

   const getData = () => {
      let dat = {type: nameUpdate};
      InfoHeaderBlock(dat)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setCurrentDta({...data[0]});
         })
         .catch(() => {});
   };

   return (
      <>
         <Accordion title={title} theme={theme} status={status} changeMode={changeMode}>
            <>
               <HeadDropDown>
                  <RightHead>
                     {!editable && (
                        <ButtonWithIcon
                           Icon={SeeIcon}
                           text="Vista previa"
                           action={() => {
                              window.open(PageWebUrl + linkWeb, "_blank");
                           }}
                        />
                     )}
                  </RightHead>
               </HeadDropDown>
               <BodyAccordion>
                  {currentData && (
                     <ToogleForm
                        change={() => setEditable(true)}
                        data={currentData}
                        save={save}
                        titleDesc={titleDesc}
                        editable={editable}
                        video={video}
                        viewTitle={viewTitle}
                     />
                  )}
               </BodyAccordion>
            </>
         </Accordion>
         <SuccesModal
            theme={theme}
            isOpen={showSuccess}
            close={() => {
               setShowSuccess(false);
               setEditable(false);
            }}
         />
         <AppLoader isVisible={isSaving} />
      </>
   );
}
ImgEncabezado.propTypes = {
   idUpdate: propTypes.number.isRequired,
   nameUpdate: propTypes.string.isRequired,
};
ImgEncabezado.defaultProps = {
   linkWeb: "",
};
const BodyAccordion = styled.div`
   padding-bottom: 1em;
`;
